import React, { useEffect, useState } from 'react';
// Simulated purchase data
const purchases = [{
  name: 'María',
  location: 'Bogotá, Colombia',
  time: 'hace 2 minutos'
}, {
  name: 'Valentina',
  location: 'Ciudad de México, México',
  time: 'hace 5 minutos'
}, {
  name: 'Camila',
  location: 'Buenos Aires, Argentina',
  time: 'hace 12 minutos'
}, {
  name: 'Sofía',
  location: 'Santiago, Chile',
  time: 'hace 1 hora'
}, {
  name: 'Isabella',
  location: 'Lima, Perú',
  time: 'hace 3 minutos'
}, {
  name: 'Lucía',
  location: 'Quito, Ecuador',
  time: 'hace 8 minutos'
}, {
  name: 'Mariana',
  location: 'San José, Costa Rica',
  time: 'hace 15 minutos'
}, {
  name: 'Daniela',
  location: 'Montevideo, Uruguay',
  time: 'hace 22 minutos'
}, {
  name: 'Valeria',
  location: 'Asunción, Paraguay',
  time: 'hace 45 minutos'
}, {
  name: 'Fernanda',
  location: 'Ciudad de Guatemala, Guatemala',
  time: 'hace 10 minutos'
}];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    // Initial delay before showing the first popup
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNextPopup = () => {
    // Pick a random purchase
    const randomIndex = Math.floor(Math.random() * purchases.length);
    setCurrentPurchase(purchases[randomIndex]);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1)) + 15000;
      setTimeout(showNextPopup, nextDelay);
    }, 5000);
  };
  return <div className={`fixed bottom-24 sm:bottom-6 left-4 sm:left-6 z-50 transition-all duration-500 ease-in-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-312">
      <div className="bg-white rounded-lg shadow-xl border border-[#E8DFD3] p-3 sm:p-4 flex items-center max-w-xs sm:max-w-sm" data-id="element-313">
        <div className="flex-shrink-0 mr-3 sm:mr-4" data-id="element-314">
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#F8F2EA] flex items-center justify-center border border-[#D4AF37]" data-id="element-315">
            <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-316">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-317" />
            </svg>
          </div>
        </div>
        <div data-id="element-318">
          <p className="text-sm sm:text-base text-[#333333] font-medium leading-tight" data-id="element-319">
            <span className="font-bold" data-id="element-320">{currentPurchase.name}</span> de{' '}
            {currentPurchase.location}
          </p>
          <p className="text-xs sm:text-sm text-[#555555] mt-1" data-id="element-321">
            Acaba de comprar la Guía Contra el Mal de Ojo
          </p>
          <p className="text-xs text-[#D4AF37] font-medium mt-1" data-id="element-322">
            {currentPurchase.time}
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 focus:outline-none" aria-label="Cerrar notificación" data-id="element-323">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-324">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-325" />
          </svg>
        </button>
      </div>
    </div>;
};